import { SelectableFieldProps } from '../core-field/selectable-field-props'

export type SelectMultiMode = 'checkbox' | 'single'

export const UI2_SELECT_FIELD_DEFAULT_PROPS: Partial<UI2SelectFieldProps> = {
  isClearable: true,
  isSearchable: true,
  isMultiSelect: false,
  allowSelectAll: true,
}

export interface UI2SelectFieldProps extends SelectableFieldProps {
  /**
   * Inline uiSchema rendered for each option. The current option is bound
   * under the namespace `option` in the renderer's state. Approved extension
   * to the selectable-field contract for components that render richer option
   * rows than a plain label (icons, metadata, custom layout).
   */
  optionTemplate?: any
  /** Allow the user to type a new option. Ignored when options come from an enum. */
  isCreatable?: boolean
  /** Default: true. */
  isClearable?: boolean
  isSearchable?: boolean
  /**
   * Multi-select interaction model.
   * - 'checkbox' — picker stays open between picks (checkboxes + Select All).
   * - 'single'   — picker closes after each pick.
   * Defaults to 'checkbox' when `isMultiSelect` is true.
   */
  multiMode?: SelectMultiMode
  /** Show Select/Deselect All in checkbox multi-mode. Default: true. */
  allowSelectAll?: boolean
  placeholder?: string
  /**
   * Title shown in the selection modal or bottom sheet. Defaults to the
   * effective placeholder when omitted.
   */
  modalTitle?: string
  /** Body of the empty-results affordance. */
  noOptionsMessage?: string
  autoFocus?: boolean
}
